export class StrutturaDTO {
  idCmu: string;
  nomeCmu: string;
  responsabileCmu: string;
}
